import React from 'react';
import theme from './NavigationContextMenu.module.scss';

interface NavigationContextMenuSeparatorProps {}

const NavigationContextMenuSeparator: React.FC<NavigationContextMenuSeparatorProps> = () => {
    return <div className={theme.separator} />;
};

export default NavigationContextMenuSeparator;
